import React, { useEffect, useRef, useState } from "react";

import "./index.scss";
import CustomView from "../CustomView";
import CustomInput from "../CustomInput";
import { ITime } from "../../types/common.interface";

type Props = {
  time: ITime;
  onChangeTime: (time: ITime) => void;
  isDisable?: boolean;
};

const CustomHourPiker = (props: Props) => {
  const refActiveHour = useRef<HTMLInputElement | null>(null);
  const [activeHour, setIsActiveHour] = useState(false);

  return (
    <section id="custom-hour-piker-content" ref={refActiveHour}>
      <CustomView.Row className="modal-content">
        <CustomView.Column medium={6} className="time-container">
          <CustomInput
            type="number"
            minLength={1}
            maxLength={2}
            value={props.time?.minute ? String(props.time?.minute) : "00"}
            onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              var thisNumber = Number(event.target.value);
              if (thisNumber <= 60 && thisNumber >= 0)
                if (thisNumber < 10)
                  props.onChangeTime({
                    ...props.time,
                    minute: String("0" + thisNumber),
                  });
                else
                  props.onChangeTime({
                    ...props.time,
                    minute: String(thisNumber),
                  });
            }}
            isDisable={props.isDisable}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="time-container">
          <CustomInput
            type="number"
            minLength={1}
            maxLength={2}
            value={props.time?.hour ? String(props.time?.hour) : "00"}
            onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              var thisNumber = Number(event.target.value);

              if (thisNumber <= 24 && thisNumber >= 0)
                if (thisNumber < 10)
                  props.onChangeTime({
                    ...props.time,
                    hour: String("0" + thisNumber),
                  });
                else
                  props.onChangeTime({
                    ...props.time,
                    hour: String(thisNumber),
                  });
            }}
            isDisable={props.isDisable}
          />
        </CustomView.Column>
      </CustomView.Row>
    </section>
  );
};

export default CustomHourPiker;
